import React from "react";
import { useState, useEffect } from "react";

import PersonalInfoCoach from "./PersonalInfoCoach";
import UpdatePassword from "../../athlete/account/UpdatePassword";
import { useAxiosInstance } from "../../../services/Interceptor";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOffers,
  fetchAccolades,
  fetchProfilePhoto,
} from "../../../store/AthleteActions";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import PaymentUpdate from "../../../components/PaymentUpdate";
import { AddOfferModal } from "./addOffer";
import { ProfileSettings } from "./profileSettings";

function AthleteData() {
  const { profilePhoto } = useSelector((state) => state.athletes);
  const authUser = useAuthUser();

  const [profilePicture, setProfilePicture] = useState(null);
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    dispatch(fetchOffers(apiInstance, authUser?.user?.id));
    dispatch(fetchAccolades(apiInstance, authUser?.user?.id));
    dispatch(fetchProfilePhoto(apiInstance, authUser?.user?.id));
  }, [dispatch, apiInstance, authUser?.user?.id]);

  useEffect(() => {
    if (profilePhoto) {
      setProfilePicture(profilePhoto);
    }
  }, [profilePhoto]);
  let [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="flex-grow sm:pb-20 xl:pb-0 lg:pb-0">
        <div className="h-full bg-gray-100">
          <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
            <div className="w-full lg:w-2/4 xl:w-2/4">
              <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300 ">
                <PersonalInfoCoach />
              </div>
              <div className=" my-4">
                <UpdatePassword title="PASSWORD SETTINGS" />
              </div>
            </div>

            <div className="w-full lg:w-2/4 xl:w-2/4">
              {/* Subscription & Billing Start */}
              {/* <SubscriptionBilling /> */}
              {/* Subscription & Billing End */}

              {/* Profile Settings Start */}
              <ProfileSettings
                profilePicture={profilePicture}
                setProfilePicture={setProfilePicture}
              />
              {/* Profile Settings End */}

              <div className="bg-white shadow-lg p-4 rounded-lg border border-gray-300 mt-4">
                <div className="w-full">
                  <div className="w-full">
                    <PaymentUpdate
                      account={authUser?.user?.id}
                      email={authUser?.user?.email}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddOfferModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}

export default AthleteData;
